import { CoverageToolbar } from './panel/coverage-dashboard/CoverageToolbar'
import { DashboardToolbar } from './panel/dashboard/DashboardToolbar'
import { IssuesToolbar } from './panel/issues/IssuesToolbar'

import type { GisScope, GisTab } from '../api/types'

export interface GisHeaderToolbarProps {
  tab: GisTab
  officerOpen: boolean
  scope: GisScope
  issuesPage: Parameters<typeof IssuesToolbar>[0]['issuesPage']
  siteMandal: Map<string, string>
  sites: Parameters<typeof CoverageToolbar>[0]['sites']
  mandals: Parameters<typeof DashboardToolbar>[0]['mandals']
  activeMandals: readonly string[]
  onSelectMandal: (name: string) => void
  onClearMandal: () => void
  onEnterGallery: () => void
  /** Dashboard-only entity scope (URL `?entityId=`). */
  entityId: string | undefined
  onEntityChange: (id: string | undefined) => void
}

/** The active tab's full-width toolbar (Dashboard, Issues or Coverage); none while an officer
 *  detail is open. */
export function GisHeaderToolbar(p: GisHeaderToolbarProps) {
  if (p.officerOpen) {
    return null
  }
  if (p.tab === 'overview') {
    return (
      <DashboardToolbar
        mandals={p.mandals}
        activeMandals={p.activeMandals}
        onSelectMandal={p.onSelectMandal}
        onClearMandal={p.onClearMandal}
        entityId={p.entityId}
        onEntityChange={p.onEntityChange}
      />
    )
  }
  if (p.tab === 'issues') {
    return (
      <IssuesToolbar
        scope={p.scope}
        issuesPage={p.issuesPage}
        siteMandal={p.siteMandal}
        activeMandals={p.activeMandals}
        onSelectMandal={p.onSelectMandal}
        onClearMandal={p.onClearMandal}
        onEnterGallery={p.onEnterGallery}
      />
    )
  }
  if (p.tab === 'coverage') {
    return (
      <CoverageToolbar
        scope={p.scope}
        sites={p.sites}
        activeMandals={p.activeMandals}
        onSelectMandal={p.onSelectMandal}
        onClearMandal={p.onClearMandal}
      />
    )
  }
  return null
}
